import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const InvestigationStepRouting = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.88003 4.6007C8.08003 1.1407 2.87002 1.1307 2.07002 4.6007C1.60002 6.6307 2.89003 8.3507 4.01003 9.4207C4.83003 10.1907 6.12003 10.1907 6.94003 9.4207C8.06003 8.3507 9.34003 6.6307 8.88003 4.6007ZM5.51003 6.2007C4.96003 6.2007 4.51003 5.7507 4.51003 5.2007C4.51003 4.6507 4.95003 4.2007 5.50003 4.2007H5.51003C6.07003 4.2007 6.51003 4.6507 6.51003 5.2007C6.51003 5.7507 6.07003 6.2007 5.51003 6.2007Z"
      fill="currentColor"
    />
    <path
      d="M21.91 16.6007C21.11 13.1407 15.88 13.1307 15.07 16.6007C14.6 18.6307 15.89 20.3507 17.02 21.4207C17.84 22.1907 19.14 22.1907 19.96 21.4207C21.09 20.3507 22.38 18.6307 21.91 16.6007ZM18.53 18.2007C17.98 18.2007 17.53 17.7507 17.53 17.2007C17.53 16.6507 17.97 16.2007 18.52 16.2007H18.53C19.08 16.2007 19.53 16.6507 19.53 17.2007C19.53 17.7507 19.08 18.2007 18.53 18.2007Z"
      fill="currentColor"
    />
    <path
      d="M11.9999 19.75H9.31994C8.15994 19.75 7.14994 19.05 6.74994 17.97C6.33994 16.89 6.63994 15.7 7.50994 14.93L15.4999 7.94C15.9799 7.52 15.9899 6.95 15.8499 6.56C15.6999 6.17 15.3199 5.75 14.6799 5.75H11.9999C11.5899 5.75 11.2499 5.41 11.2499 5C11.2499 4.59 11.5899 4.25 11.9999 4.25H14.6799C15.8399 4.25 16.8499 4.95 17.2499 6.03C17.6599 7.11 17.3599 8.3 16.4899 9.07L8.49994 16.06C8.01994 16.48 8.00994 17.05 8.14994 17.44C8.29994 17.83 8.67994 18.25 9.31994 18.25H11.9999C12.4099 18.25 12.7499 18.59 12.7499 19C12.7499 19.41 12.4099 19.75 11.9999 19.75Z"
      fill="currentColor"
    />
  </svg>
)

export default withDefaultStyles(InvestigationStepRouting)
